(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('lab-log', {
                parent: 'entity',
                url: '/lab-log',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_SYSTEM_ADMIN'],
                    pageTitle: 'LabLogs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/lab-log/lab-logs.html',
                        controller: 'LabLogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            });
    }
})();
